export const language = {
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',

    'New Address': 'New Address',
    'Default Address': 'Default Address',
    'Common Address': 'Common Address',
    'Set to Default Address': 'Set to Default Address',
    'Contact Name ': 'Contact Name ',
    'Please Entry Contact Name ': 'Please Entry Contact Name ',
    'Contact Information': 'Contact Information',
    'Please Entry Contact Information': 'Please Entry Contact Information',
    'Country': 'Country',
    'Detail Address': 'Detail Address',
    'Please Entry Detail Address': 'Please Entry Detail Address',
    'Post Code': 'Post Code',
    'Please Entry Post Code': 'Please Entry Post Code',
    'Remarks': 'Remarks',
    'Please confirm to delete this address': 'Please confirm to delete this address',
  },
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',

    'New Address': '新增地址',
    'Default Address': '默认地址',
    'Common Address': '常用地址',
    'Set to Default Address': '设为默认地址',
    'Contact Name ': '联系人姓名',
    'Please Entry Contact Name ': '请输入联系人姓名',
    'Contact Information': '联系方式',
    'Please Entry Contact Information': '请输入联系方式',
    'Country': '国家',
    'Detail Address': '详细地址',
    'Please Entry Detail Address': '请输入详细地址',
    'Post Code': '邮政编码',
    'Please Entry Post Code': '请输入邮政编码',
    'Remarks': '备注',
    'Please confirm to delete this address': '请确认是否删除该地址',
  }
};
